import DownloadIcon from "@mui/icons-material/GetApp";
import {
  Box,
  CircularProgress,
  Grid,
  Link,
  LinearProgress,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import DownloadFileDirect from "../../unit/DownloadFileDirect";
import DownloadFileGenerated from "../../unit/DownloadFileGenerated";
import CheckBoxList from "../../unit/forms/CheckBoxList";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import downloadFileFun from "../../unit/DownloadFileFun";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";
import DownloadFieldLink from "../../unit/DownloadFieldLink";

export default function CustomToNotify2DeclinedFormDialog({ ...props }) {
  const PREVIEW_STEPS = {
    save: "Saving data...",
    generate: "Generating file on server...",
    download: "Downloading to browser...",
  };
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const cbfun = props?.cb;
  const [open, setOpen] = React.useState(false);
  const [showCreditBureau, setShowCreditBureau] = React.useState(false);
  const [showFico, setShowFico] = React.useState(false);
  const [showAdverseAction, setShowAdverseAction] = React.useState(false);
  const [showOutsideSource, setShowOutsideSource] = React.useState(false);
  const [reasons_adverse_action_selected, setReasonsAdverseActionSelected] =
    React.useState<{ label: string; value: string }[]>([]);
  const [outsideSourceSelected, setOutsideSourceSelected] = React.useState<
    string[]
  >([]);
  const [creditValSlected, setCreditValSlected] = React.useState<string[]>([]);
  const [previewTitle, setPreviewTitle] = React.useState("Preview");
  const [isPreviewLoading, setIsPreviewLoading] = React.useState(false);
  const [previewProgress, setPreviewProgress] = React.useState(0);
  const [previewProgressLabel, setPreviewProgressLabel] = React.useState("");
  const previewProgressRef = React.useRef(0);
  const generateProgressTimerRef = React.useRef<ReturnType<
    typeof setInterval
  > | null>(null);
  const downloadStartProgressRef = React.useRef(25);
  const [submitTitle, setSubmitTitle] = React.useState("Decline");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [filePath, setFilePath] = React.useState("");
  const [generateFileInfo, setGenerateFileInfo] = React.useState<{
    filename: string;
    filetype: string;
    filekey: string;
    filelink?: string;
    docId: number;
  } | null>(null);
  const [declineData, setDeclineData] = React.useState({
    sAdverseAction: [],
    sReportingAgency: [],
    sFicoRiskFactor: [],
    sUsedCreditInfo: [],
  });
  const refresh = useRefresh();

  React.useEffect(() => {
    previewProgressRef.current = previewProgress;
  }, [previewProgress]);

  const updatePreviewProgress = (progress: number, label: string) => {
    setPreviewProgress(progress);
    setPreviewProgressLabel(label);
  };

  const clearGenerateProgressTimer = () => {
    if (generateProgressTimerRef.current) {
      clearInterval(generateProgressTimerRef.current);
      generateProgressTimerRef.current = null;
    }
  };

  const startGenerateProgressTimer = () => {
    clearGenerateProgressTimer();
    generateProgressTimerRef.current = setInterval(() => {
      setPreviewProgress((prev) => {
        if (prev >= 84) {
          return prev;
        }

        const step = prev < 18 ? 0.8 : prev < 40 ? 1.2 : prev < 64 ? 0.9 : 0.45;

        return Math.min(84, Number((prev + step).toFixed(2)));
      });
    }, 500);
  };

  const resetPreviewLoadingState = () => {
    clearGenerateProgressTimer();
    setPreviewTitle("Preview");
    setIsPreviewLoading(false);
    setPreviewProgress(0);
    setPreviewProgressLabel("");
    downloadStartProgressRef.current = 25;
  };

  const resetSubmitState = () => {
    setSubmitTitle("Decline");
    setIsSubmitting(false);
  };

  React.useEffect(() => {
    return () => {
      clearGenerateProgressTimer();
    };
  }, []);

  const handleClickOpen = () => {
    const reqUrl = `applications/declineCounterReason`;
    sendRequest(reqUrl, { id: appId }).then((response) => {
      if (response) {
        const data = response;
        if (data) {
          const sAdverseAction = data.sAdverseAction
            ? data.sAdverseAction.split(",")
            : [];
          const sReportingAgency = data.sReportingAgency
            ? data.sReportingAgency.split(",")
            : [];
          const sFicoRiskFactor = data.sFicoRiskFactor
            ? data.sFicoRiskFactor.split(",")
            : [];
          const sUsedCreditInfo = data.sUsedCreditInfo
            ? data.sUsedCreditInfo.split(",")
            : [];
          setDeclineData({
            sAdverseAction: sAdverseAction,
            sReportingAgency: sReportingAgency,
            sFicoRiskFactor: sFicoRiskFactor,
            sUsedCreditInfo: sUsedCreditInfo,
          });
          setOutsideSourceSelected(sReportingAgency);
          setCreditValSlected(sUsedCreditInfo);
          setReasonsAdverseActionSelected(sAdverseAction);
          setShowAdverseAction(true);
          setShowOutsideSource(true);
        }
      }
    });

    setOpen(true);
    setFilePath("");
    setGenerateFileInfo(null);
  };

  const handleClose = () => {
    setOpen(false);
    setFilePath("");
    setGenerateFileInfo(null);
    resetPreviewLoadingState();
    resetSubmitState();
    refresh();
  };

  const formatRate = (num: any) => {
    if (num == "" || num == null || num == 0) {
      return "0.00%";
    } else {
      return num + "%";
    }
  };

  const defautRateOptionList: { label: string; value: any }[] = [];
  defautRateOptionList.push({ label: "Select", value: "" });
  if (record.rateData) {
    for (let i = 0; i < Object.keys(record.rateData).length; i++) {
      defautRateOptionList.push({
        label: formatRate(record.rateData[i]),
        value: record.rateData[i],
      });
    }
  }

  const defautTermsList = [];
  defautTermsList.push({ label: "Select", value: "" });
  if (record?.termsData) {
    for (let i = 0; i < record.termsData.length; i++) {
      defautTermsList.push({
        label: record.termsData[i],
        value: record.termsData[i],
      });
    }
  }

  const defautPaymentFreqList = [];
  if (record?.paymentFrequencyData) {
    for (let i = 0; i < record.paymentFrequencyData.length; i++) {
      defautPaymentFreqList.push({
        label: record.paymentFrequencyData[i].name,
        value: record.paymentFrequencyData[i].bbkey,
      });
    }
  }

  const reasons_adverse_action_list: { label: string; value: string }[] = [];
  if (record.adverseData) {
    record.adverseData.map((adverse: any) => {
      reasons_adverse_action_list.push({
        label: adverse.name,
        value: adverse.id,
      });
    });
  }
  const outside_source_list: { label: string; value: string }[] = [];
  if (record.agencyData) {
    record.agencyData.map((agency: any) => {
      outside_source_list.push({ label: agency.name, value: agency.id });
    });
  }

  const fico_list: { label: string; value: string }[] = [];
  if (record.ficoriskFactorData) {
    record.ficoriskFactorData.map((fico: any) => {
      fico_list.push({ label: fico.name, value: fico.id });
    });
  }
  const fico_selected: { label: string; value: string }[] =
    declineData.sFicoRiskFactor;

  const credit_infor_used_list: { label: string; value: string }[] = [];
  credit_infor_used_list.push({
    label: "Credit Report",
    value: "Credit Report",
  });
  credit_infor_used_list.push({ label: "Credit Score", value: "Credit Score" });
  const credit_infor_used_selected: { label: string; value: string }[] =
    declineData.sUsedCreditInfo;

  const handleClickAdverseAction = (event: any) => {
    if (event.target.checked) {
      setReasonsAdverseActionSelected([
        ...reasons_adverse_action_selected,
        event.target.value,
      ]);
    } else {
      setReasonsAdverseActionSelected(
        reasons_adverse_action_selected.filter(
          (item) => item !== event.target.value
        )
      );
    }
  };

  const handleClickOutsideSource = (event: any) => {
    if (event.target.checked) {
      setOutsideSourceSelected([...outsideSourceSelected, event.target.value]);
    } else {
      setOutsideSourceSelected(
        outsideSourceSelected.filter((item) => item !== event.target.value)
      );
    }
  };

  const handleClickCreditInforUsed = (event: any) => {
    if (event.target.checked) {
      setCreditValSlected([...creditValSlected, event.target.value]);
    } else {
      setCreditValSlected(
        creditValSlected.filter((item) => item !== event.target.value)
      );
    }
  };

  React.useEffect(() => {
    if (outsideSourceSelected.length > 0) {
      var select_agency_list = outsideSourceSelected.join(",");
      if (
        select_agency_list.indexOf("1") != -1 ||
        select_agency_list.indexOf("2") != -1 ||
        select_agency_list.indexOf("3") != -1 ||
        select_agency_list.indexOf("4") != -1
      ) {
        setShowCreditBureau(true);
      } else {
        setShowCreditBureau(false);
      }
    }
  }, [outsideSourceSelected]);

  React.useEffect(() => {
    if (creditValSlected.length > 0) {
      const creditValSlectedVal = creditValSlected.join(",");
      if (creditValSlectedVal.indexOf("Credit Score") != -1) {
        setShowFico(true);
      } else {
        setShowFico(false);
      }
    }
  }, [creditValSlected]);

  React.useEffect(() => {}, [filePath]);

  const handlePreviewDecline = async ({ ...props }) => {
    if (isSubmitting) {
      return;
    }

    const { appId } = props;
    setIsPreviewLoading(true);
    setPreviewTitle("loading");
    updatePreviewProgress(8, PREVIEW_STEPS.save);
    const reqUrl = `applications/actions/saveappinfo`;

    const formData = new FormData();
    const formJson = Object.fromEntries((formData as any).entries());
    let form_adverse_select: string[] = [];
    var checkboxes = document.querySelectorAll(
      "#toNotify2DeclinedFormDialog" + appId + ' [name^="reasons_adverse[]"]'
    );
    checkboxes.forEach((checkbox) => {
      const inputElement = checkbox as HTMLInputElement;
      if (inputElement.checked) {
        form_adverse_select.push(inputElement.value);
      }
    });

    let form_agency_select: string[] = [];
    checkboxes = document.querySelectorAll(
      "#toNotify2DeclinedFormDialog" + appId + ' [name^="outside_source[]"]'
    );
    checkboxes.forEach((checkbox) => {
      const inputElement = checkbox as HTMLInputElement;
      if (inputElement.checked) {
        form_agency_select.push(inputElement.value);
      }
    });

    let form_credit_infor_used_selected: string[] = [];
    checkboxes = document.querySelectorAll(
      "#toNotify2DeclinedFormDialog" +
        appId +
        ' [name^="credit_infor_used_selected[]"]'
    );
    checkboxes.forEach((checkbox) => {
      const inputElement = checkbox as HTMLInputElement;
      if (inputElement.checked) {
        form_credit_infor_used_selected.push(inputElement.value);
      }
    });
    let form_fico_select: string[] = [];
    checkboxes = document.querySelectorAll(
      "#toNotify2DeclinedFormDialog" + appId + ' [name^="fico[]"]'
    );
    checkboxes.forEach((checkbox) => {
      const inputElement = checkbox as HTMLInputElement;
      if (inputElement.checked) {
        form_fico_select.push(inputElement.value);
      }
    });

    formJson.adverse = form_adverse_select.join(",");
    formJson.fico = form_fico_select.join(",");
    formJson.agency = form_agency_select.join(",");
    formJson.credit_infor = form_credit_infor_used_selected.join(",");

    if (formJson.adverse == "") {
      errorNotify("Please select Reasons for Adverse Action");
      resetPreviewLoadingState();
      return;
    }
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Data saved successfully");
      updatePreviewProgress(18, PREVIEW_STEPS.generate);
      startGenerateProgressTimer();
      await downloadFileFun(
        appId,
        "decline_preview.pdf",
        "execute2decline_preview",
        "",
        {
          onError: (message: string) => {
            errorNotify(message);
          },
          onStageChange: (stage) => {
            if (stage === "generating") {
              updatePreviewProgress(
                Math.max(previewProgressRef.current, 18),
                PREVIEW_STEPS.generate
              );
              startGenerateProgressTimer();
            }

            if (stage === "downloading") {
              clearGenerateProgressTimer();
              downloadStartProgressRef.current =
                previewProgressRef.current > 18
                  ? previewProgressRef.current
                  : 18;
              setPreviewProgressLabel(PREVIEW_STEPS.download);
            }
          },
          onDownloadProgress: (percent) => {
            if (typeof percent !== "number") {
              setPreviewProgress((prev) => Math.min(99, prev + 0.2));
              return;
            }

            const base = downloadStartProgressRef.current;
            const mapped = base + (percent / 100) * (100 - base);

            setPreviewProgress((prev) =>
              Math.max(prev, Math.min(100, Math.round(mapped)))
            );
          },
        }
      );
      clearGenerateProgressTimer();
      setPreviewProgress(100);
      await new Promise((resolve) => setTimeout(resolve, 600));
      resetPreviewLoadingState();
    } else {
      errorNotify("Data not saved");
      resetPreviewLoadingState();
    }
  };

  const handleDeclineSend = async ({ ...props }) => {
    if (isSubmitting || isPreviewLoading) {
      return;
    }

    let { appId } = props;
    const reqUrl = `applications/actions/notify/toDecline`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: { option: "decline" },
    });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Data saved successfully");
      if (cbfun) {
        cbfun("Declined");
      }
      handleClose();
    }
  };

  const [showDeclineDownloadIcon, setShowDeclineDownloadIcon] =
    React.useState(false);
  const handleDownloadDeclinedPDF = async () => {
    setShowDeclineDownloadIcon(true);
    await downloadFileFun(appId, appId + "-decline", "decline", filePath);
    setTimeout(() => {
      setShowDeclineDownloadIcon(false);
    }, 1000);
  };
  return (
    <React.Fragment>
      <Button
        id="btn-application-tonotify-decline"
        label="Decline"
        variant="contained"
        size="medium"
        color="error"
        sx={{ marginLeft: "10px", width: "120px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        id={"toNotify2DeclinedFormDialog" + appId}
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            if (isSubmitting || isPreviewLoading) {
              return;
            }

            setIsSubmitting(true);
            setSubmitTitle("loading");
            const formData = new FormData();
            const formJson = Object.fromEntries((formData as any).entries());

            let form_adverse_select: string[] = [];
            var checkboxes = document.querySelectorAll(
              "#toNotify2DeclinedFormDialog" +
                appId +
                ' [name^="reasons_adverse[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_adverse_select.push(inputElement.value);
              }
            });

            let form_agency_select: string[] = [];
            checkboxes = document.querySelectorAll(
              "#toNotify2DeclinedFormDialog" +
                appId +
                ' [name^="outside_source[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_agency_select.push(inputElement.value);
              }
            });

            let form_credit_infor_used_selected: string[] = [];
            checkboxes = document.querySelectorAll(
              "#toNotify2DeclinedFormDialog" +
                appId +
                ' [name^="credit_infor_used_selected[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_credit_infor_used_selected.push(inputElement.value);
              }
            });

            let form_fico_select: string[] = [];
            checkboxes = document.querySelectorAll(
              "#toNotify2DeclinedFormDialog" + appId + ' [name^="fico[]"]'
            );
            checkboxes.forEach((checkbox) => {
              const inputElement = checkbox as HTMLInputElement;
              if (inputElement.checked) {
                form_fico_select.push(inputElement.value);
              }
            });

            formJson.adverse = form_adverse_select.join(",");
            formJson.fico = form_fico_select.join(",");
            formJson.agency = form_agency_select.join(",");
            formJson.credit_infor = form_credit_infor_used_selected.join(",");
            formJson.option = "decline";
            if (formJson.adverse == "") {
              errorNotify("Please select Reasons for Adverse Action");
              setPreviewTitle("Preview");
              resetSubmitState();
              return;
            }
            const reqUrl = `applications/actions/saveappinfo`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              const filetype = "decline_preview.pdf";
              const filekey = "execute2decline_preview";
              const generalFileUrl = "applications/pdfs/fillForm/generatedPdf";
              formJson.filetype = filetype;
              formJson.filekey = filekey;
              formJson.exectype = "acceptUpload";
              formJson.sReview = "decline";
              const fileResponse = await sendRequest(generalFileUrl, {
                id: appId,
                data: formJson,
              });
              if (fileResponse.code == 200) {
                successNotify("Data saved successfully");
                const fileUrl = fileResponse.filekey;

                setFilePath(fileUrl);
                setGenerateFileInfo({
                  filename:
                    fileResponse?.filename || fileResponse?.filekey || "",
                  filetype: fileResponse?.filetype || "",
                  filekey: fileResponse?.filekey || "",
                  filelink: fileResponse?.filelink || "",
                  docId: fileResponse?.docId || 0,
                });
                resetSubmitState();
              } else {
                errorNotify(fileResponse?.message || "File generation failed!");
                resetSubmitState();
              }
            } else {
              errorNotify("Data not saved");
              setPreviewTitle("Preview");
              resetSubmitState();
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Decline" />
        </DialogTitle>
        <DialogContent sx={{ overflowY: "scroll" }}>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          {filePath ? (
            <>
              <List
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  bgcolor: "background.paper",
                }}
              >
                <ListItem key={appId}>
                  <Link
                    sx={{
                      fontSize: "16px",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    // onClick={handleDownloadDeclinedPDF}
                  >
                    Decline PDF
                    {/* {!showDeclineDownloadIcon && (
                      <DownloadIcon
                        sx={{ fontSize: "20px", verticalAlign: "Bottom" }}
                      />
                    )}
                    {showDeclineDownloadIcon && (
                      <CircularProgress
                        size={16}
                        color="inherit"
                        sx={{
                          marginLeft: "10px",
                          verticalAlign: "Bottom",
                        }}
                      />
                    )} */}
                    {generateFileInfo && generateFileInfo.filekey && (
                      <DownloadFieldLink
                        key={`doc_link_${appId}_${generateFileInfo.docId}_${
                          generateFileInfo?.filename || "na"
                        }_${String(generateFileInfo?.filelink || "na")}`}
                        // filename={appId + "_" + generateFileInfo?.filename}
                        filename={appId + "_Decline PDF"}
                        filelink={generateFileInfo?.filelink}
                      />
                    )}
                  </Link>
                </ListItem>
                <ListItem key="text-body">
                  <Typography variant="body2" color="text.secondary">
                    Application {appId} status has been updated to Declined. To
                    review this application, please select "Declined" in the
                    drop down menu.
                  </Typography>
                </ListItem>
              </List>
            </>
          ) : (
            <>
              <Grid container sx={{ mb: 2, pb: 2 }}>
                {showAdverseAction && (
                  <Grid sx={{ mb: 2 }} container>
                    <CheckBoxList
                      id="reasons_adverse"
                      name="reasons_adverse[]"
                      list={reasons_adverse_action_list}
                      selectedlist={reasons_adverse_action_selected}
                      title="Reasons For Adverse Action"
                      handleClick={handleClickAdverseAction}
                    />
                  </Grid>
                )}

                {showOutsideSource && (
                  <Grid sx={{ mb: 2 }} container>
                    <CheckBoxList
                      id="outside_source"
                      name="outside_source[]"
                      list={outside_source_list}
                      selectedlist={outsideSourceSelected}
                      title="Outside Source Of Information"
                      handleClick={handleClickOutsideSource}
                    />
                  </Grid>
                )}

                {showCreditBureau && (
                  <Grid sx={{ mb: 2 }} container>
                    <CheckBoxList
                      id="credit_infor_used_selected"
                      name="credit_infor_used_selected[]"
                      list={credit_infor_used_list}
                      selectedlist={creditValSlected}
                      title="Please select credit bureau information used"
                      handleClick={handleClickCreditInforUsed}
                    />
                  </Grid>
                )}

                {showFico && (
                  <Grid sx={{ mb: 2 }} container>
                    <CheckBoxList
                      id="fico"
                      name="fico[]"
                      list={fico_list}
                      selectedlist={fico_selected}
                      title="Fico Risk Factor"
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />

          {filePath ? (
            <>
              <Button
                label="Send"
                variant="contained"
                size="medium"
                sx={{ width: "120px" }}
                disabled={isSubmitting || isPreviewLoading}
                onClick={() => handleDeclineSend({ appId })}
              />
            </>
          ) : (
            <>
              {!isPreviewLoading && (
                <Button
                  label={previewTitle}
                  variant="text"
                  endIcon={
                    isPreviewLoading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                  size="medium"
                  color="warning"
                  sx={{ width: "120px" }}
                  onClick={() => handlePreviewDecline({ appId })}
                  disabled={isPreviewLoading || isSubmitting}
                />
              )}
              {isPreviewLoading && (
                <Box sx={{ width: "260px", ml: 1 }}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mb: 0.5 }}
                  >
                    {previewProgressLabel}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={previewProgress}
                      sx={{
                        flex: 1,
                        height: 10,
                        borderRadius: 5,
                        backgroundColor: "#bbdefb",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#1976d2",
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ color: "#1565c0", minWidth: "40px" }}
                    >
                      {Math.round(previewProgress)}%
                    </Typography>
                  </Box>
                </Box>
              )}
              <CustomButtonSubmit
                label={submitTitle}
                disabled={isPreviewLoading || isSubmitting}
                color="error"
              />
              {/* <Button
                label="roll back"
                onClick={() => setSubmitTitle("Submit")}
              /> */}
            </>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
